// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zQ7l","name":"styles_name__2NiAm","phone":"styles_phone__9arcf"};